import type { Candidate } from 'model/Candidate/Candidate';
import { CANDIDATE_STATUS } from 'services/candidates/types';
import { CampaignJobboard } from '../SelectedCampaignContext/SelectedCampaignContext.types';

export type CommAgentFlow = 'email' | 'indeed' | 'whatsapp';

export type CommAgentFlowGates = {
  isIndeedCommAgentFlowEnabled: boolean;
  isIndeedLoggedIn: boolean;
  isRJCommHubEnabled: boolean;
  isWaCommunicationAgentEnabled: boolean;
};

type CommAgentFlowEligibilityOptions = {
  considerOptOut: boolean;
};

const getCommAgentFlowForCandidate = (
  candidate: Candidate,
  gates: CommAgentFlowGates,
  { considerOptOut }: CommAgentFlowEligibilityOptions,
): CommAgentFlow | null => {
  if (candidate.status === CANDIDATE_STATUS.MATCHED) return null;
  if (considerOptOut && candidate.communicationOptOut) return null;

  const hasEmail = !!candidate.contact_info?.email;
  const hasPhone = !!candidate.contact_info?.phone;
  const isIndeed = candidate.activeJobBoard === CampaignJobboard.Indeed;

  if (hasEmail) {
    return gates.isRJCommHubEnabled ? 'email' : null;
  }

  if (isIndeed) {
    if (!gates.isIndeedCommAgentFlowEnabled) return null;
    if (!gates.isIndeedLoggedIn) return null;

    return 'indeed';
  }

  if (hasPhone && gates.isWaCommunicationAgentEnabled && gates.isRJCommHubEnabled) {
    return 'whatsapp';
  }

  return null;
};

export const getCommAgentFlow = (
  candidate: Candidate | null | undefined,
  gates: CommAgentFlowGates,
): CommAgentFlow | null => {
  if (!candidate) return null;

  return getCommAgentFlowForCandidate(candidate, gates, { considerOptOut: true });
};

export const isRjCommHubChannelEnabled = (
  candidate: Candidate | null | undefined,
  gates: CommAgentFlowGates,
): boolean => {
  if (!candidate) return false;

  return getCommAgentFlowForCandidate(candidate, gates, { considerOptOut: false }) !== null;
};
